module.exports = __webpack_public_path__ + "img/1.6a75a7f4.png";